<template>
  <div class="flex justify-center">
    <div
        class="container text-center px-4 py-8 mx-auto"
    >
      <header class="mb-8">
        <Heading3 custom-style="mb-4" text="Добро пожаловать в Буйян"/>
        <p class="text-lg text-gray-600 dark:text-gray-400">
          У нас вы найдете лучшие товары, вакансии и резюме.
        </p>
      </header>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        <div
            v-for="item in items"
            :key="item.text"
            class="group relative rounded-lg overflow-hidden shadow-lg"
        >
          <!-- Background Image Wrapper -->
          <div class="absolute inset-0 overflow-hidden">
            <div
                :style="{ backgroundImage: `url(${item.resolvedImgSrc})` }"
                class="absolute inset-0 bg-cover bg-center transform transition-transform duration-500 group-hover:scale-110"
            ></div>
          </div>

          <!-- Overlay -->
          <div
              class="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-60 transition-all duration-300"
          ></div>

          <!-- Content -->
          <router-link
              :to="item.href"
              class="relative flex flex-col items-center justify-center h-full text-white p-4"
          >
            <h2 class="text-xl font-bold mb-2">{{ item.text }}</h2>
            <p class="text-sm">{{ item.description }}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {ref, onMounted} from 'vue'
import {useNavigation} from "@/router.js"
import Heading3 from "@/core/components/material/v1/text/Heading3.vue"

const {routes} = useNavigation()

const items = ref([
  {
    text: "Вакансии",
    description: "Поиск работы и предложений от работодателей.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/vacancy.jpg"),
    href: routes.VACANCIES.path,
  },
  {
    text: "Резюме",
    description: "Создайте резюме, чтобы работодатели вас нашли.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/resume.webp"),
    href: routes.RESUMES.path,
  },
  {
    text: "Услуги",
    description: "Предлагайте и находите услуги от проверенных специалистов.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/offering.jpg"),
    href: routes.OFFERINGS.path,
  },
  {
    text: "Товары",
    description: "Покупайте и продавайте товары на площадке.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/offering.jpg"),
    href: routes.PRODUCTS.path,
  },
  {
    text: "Недвижимость",
    description: "Аренда и продажа недвижимости.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/realty.jpg"),
    href: routes.REALTY.path,
  },
  {
    text: "Быстрые объявления",
    description: "Быстро находите исполнителей для срочных задач.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/offering.jpg"),
    href: routes.QUICK_POST_LIST.path,
  },
  {
    text: "Новости",
    description: "Актуальные новости и события платформы.",
    showToAuthorized: true,
    imgSrc: () => import("@/assets/images/offering.jpg"),
    href: routes.NEWS.path,
  },
])

const loadImages = async () => {
  for (let item of items.value) {
    const imgModule = await item.imgSrc()
    item.resolvedImgSrc = imgModule.default
  }
}

onMounted(async () => {
  await loadImages()
})
</script>


<style scoped>
/* Карточки разделов */
.group {
  position: relative;
  height: 160px; /* Высота карточек */
  overflow: hidden; /* Обрезка увеличенной картинки */
}

.group:hover .group-hover\:bg-opacity-60 {
  @apply bg-opacity-60;
}

.group h2 {
  @apply text-xl font-bold;
}

.group p {
  @apply text-sm;
}

/* Изображение внутри блока */
.group div:first-child div {
  transition: transform 0.5s ease-in-out;
}

.group:hover div:first-child div {
  transform: scale(1.1); /* Увеличение изображения */
}

/* Оверлей */
.group:hover .group-hover\:bg-opacity-60 {
  @apply bg-opacity-60;
}
</style>
